/* eslint-disable angular/document-service */
export const assignAgentDropdownController = $scope => {
  $scope.openAgentDropdown = event => {
    event.stopPropagation()
  }

  $scope.filterAssignAgent = () => {
    $scope.data.filteredAgentList = $scope.data.agentsList.filter(x =>
      x.email.contains(document.querySelector('#filter-agents').value)
    )
  }

  $scope.selectedAgent = selectedvalue => {
    const elements = document.querySelectorAll('.clickedSelected')
    ;[].forEach.call(elements, element => {
      element.classList.remove('clickedSelected')
    })
    // eslint-disable-next-line unicorn/prefer-query-selector
    let selectedAgentValue = document.getElementById(selectedvalue.id)
      .firstElementChild
    selectedAgentValue.classList.add('clickedSelected')
    $scope.selectedAgentValue = selectedvalue
  }

  $scope.closeAgentList = () => {
    const elements = document.querySelectorAll('.clickedSelected')

    ;[].forEach.call(elements, element => {
      element.classList.remove('clickedSelected')
    })
    $scope.gridOptions.api.deselectAll()
    $('#agentsDropdownList').hide()
  }
}



// WEBPACK FOOTER //
// ./scripts/shared/directives/assign-agent-dropdown/assign-agent-dropdown.ctrl.js